import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { mustMatch } from './custom-matching-validator';

@Directive({
  selector: '[mustMatch]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomMatchingDirective, multi: true }]
})

export class CustomMatchingDirective implements Validator {
  @Input('mustMatch') mustMatch: string[] = [];

  validate(formGroup: FormGroup): ValidationErrors {
    return mustMatch(this.mustMatch[0], this.mustMatch[1])(formGroup);
  }
}
